import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, Subject, of } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { DynamicFormDesignerConfig } from '../utils/dynamic-form-designer-config';
import { skipErrorHandler } from '../utils/http-helper';
import { OptionProperty } from '../types';
import { CascadeParentValue, AbstractControl } from '../types/control.types';
import { resolveUrl, getValueByProperty } from '../utils/utils';

/**
 * è¿ç¨æ°æ®æºå¤çæå¡
 */
@Injectable({
  providedIn: 'root'
})
export class RemoteDataSourceService {
  private _config: DynamicFormDesignerConfig;

  constructor(private httpClient: HttpClient, config: DynamicFormDesignerConfig) {
    this._config = config;
    this.httpClient = skipErrorHandler(this.httpClient);
  }

  get(url: string): Observable<any> {
    url = resolveUrl(url, this._config.optionDataSource.baseUrl);
    return this.httpClient.get(url).pipe();
  }

  /**
   * è·åé»è®¤å¼ æ ¹æ®åºå®éé¡¹
   *
   * @memberof OptionService
   */
  getDefaultValueByProperty(property: OptionProperty, newValue: string = ''): Observable<any> {
    const sub: Subject<any> = new Subject<any>();
    const option: OptionProperty = property;
    if (!option) {
      return of([]);
    }
    // æ°æ®æºæ°æ®
    if (option.id === 'dataSource') {
      const valueMember = 'data';
      if (!option.value) {
        return of([]);
      }
      // http è¯·æ±
      this.get(this.getUrl(option.value, newValue))
        .pipe(
          finalize(() => {
            sub.complete();
          })
        )
        .subscribe(
          (r: any) => {
            if (r) sub.next(r[valueMember]);
          },
          (e: any) => {
            sub.error(e);
          }
        );
      return sub;
    }
    // èªå®ä¹æ°æ®
    setTimeout(() => {
      sub.next(option.value);
      sub.complete();
    }, 0);

    return sub;
  }

  /**
   * è·åè®¡ç®åçurl
   *
   * @param  url
   * @param  newVal
   * @memberof OptionService
   */
  getUrl(url: string, newVal: string): string {
    const varName = this.getVarName(url);
    if (!varName) {
      return url;
    }
    return url.replace(`\${${varName}\}`, newVal);
  }

  /**
   * è·ååéåç§°
   *
   * @memberof OptionService
   */
  getVarName(url: string): string {
    if (!url) {
      return '';
    }

    // firefox ä¸æ¯æåè¡æ­è¨ï¼æä»¥è¦æªä¸ä¸å­ç¬¦ä¸²
    const matches = url.match(/(\$\{)[\\_\.A-Za-z0-9]+(\})+/g);

    if (matches && matches.length > 0) {
      const varName = matches[0];
      return varName.substring(2, varName.length - 1);
    }
    return '';
  }

  /**
   *
   * è·åçº§èçæ¿æ¢å¼ä¹åçUrl
   */
  getUrlByCascade(control: AbstractControl<any>, values: CascadeParentValue[], url: string): string {
    let domain: string = url.split('?')[0];
    let params: string = url.split('?')[1] || '';
    domain = this.setDomainParam(control, values, domain);
    params = this.setQueryParam(control, values, params);
    return domain + params;
  }

  setDomainParam(control: AbstractControl<any>, values: CascadeParentValue[], url: string): string {
    return this.replaceCascadeMatchValues(control, values, url);
  }

  setQueryParam(control: AbstractControl<any>, values: CascadeParentValue[], url: string) {
    if (!url) {
      return '';
    }
    let params: string[] = url.split('&');
    params = params.map((s) => {
      return this.replaceCascadeMatchValues(control, values, s, true);
    });
    let queryUrl = '?';
    params.forEach((s, index) => {
      queryUrl += s;
      if (index < params.length - 1) {
        queryUrl += '&';
      }
    });
    return queryUrl;
  }

  getDataByUrl(url: string) {
    url = decodeURI(url);
    return this.get(url);
  }

  /**
   *
   * æ¿æ¢çº§èå¹éå¼
   * @param values
   * @param url
   * @param isEncodeURI æ¯å¦ç¼ç å¼
   */
  replaceCascadeMatchValues(
    control: AbstractControl<any>,
    values: CascadeParentValue[],
    url: string,
    isEncodeURI?: boolean
  ) {
    if (!url) {
      return url;
    }
    // æ¯æè§å ${0}ã${0.property}ã${TextBox2}ã${TextBox2.property} 0æ¯å³èççº§èä¸çº§é¡ºåº

    // (\$\{)(\w+)(|(\.\w+)+)(\})
    // ${textjbox2_2}uuuu${0.code_1.xxdsa_.3}

    const matches = url.match(/(\$\{)(\w+)(|(\.\w+)+)(\})/g);
    if (matches && matches.length > 0) {
      matches.forEach((match) => {
        const indexStr = match.substring(2, match.length - 1);
        // åç¬¬ä¸ä¸ª.ä¹åçå½åKEYï¼ä¹åçå½åå±æ§
        const key = indexStr.split('.')[0];
        let property = '';
        if (key.length !== indexStr.length) {
          property = indexStr.substring(key.length + 1);
        }

        // åæ ¹æ®keyè·åï¼å¦ææ²¡æåæ ¹æ®keyéåææçº§èçå¼
        // ä¸çº§åç§°æ¯å¸¦å±æ§çï¼ç¨æ§ä»¶åç§°è¿ç§åå¼å°±ä¼åä¸å°ï¼ ç¨æ§ä»¶åç§°åå¼çè¿ç§ï¼å¼ä¸­çpropertyéè¦æ¸ç©º
        let parentValue = values[key];
        if (!parentValue) {
          const valueByName = values.find((s) => s.name === key);
          if (valueByName) {
            parentValue = JSON.parse(JSON.stringify(valueByName));
            parentValue.property = '';
          } else {
            throw new Error('çº§èæ°æ®ä¸­æ²¡ææ¾å°å¹éçå¼ï¼');
          }
        }

        let value = this.getCascadeParentValue(parentValue, null);
        value = getValueByProperty(value, property);
        if (isEncodeURI) {
          value = encodeURIComponent(value);
        }
        url = url.replace(match, value);
      });
    }

    url = this.replaceUrlMatchValueFromControl(control, url, isEncodeURI);
    return url;
  }

  /**
   * æ¿æ¢ä»æ§ä»¶æ¬èº«è·åå°çå¼
   * æ¯æè§å ${$dataConfig.formCode}
   */
  replaceUrlMatchValueFromControl(control: AbstractControl<any>, url: string, isEncodeURI?: boolean) {
    const matches = url.match(/(\$\{\$)[A-Za-z][A-Za-z0-9\.]+(\})+/g);

    if (matches && matches.length > 0) {
      matches.forEach((match) => {
        const matchKey = match.substring(3, match.length - 1);
        let value = getValueByProperty(control, matchKey);
        if (isEncodeURI) {
          value = encodeURIComponent(value);
        }
        url = url.replace(match, value);
      });
    }
    return url;
  }

  getCascadeParentValue(cascade: CascadeParentValue, defaultValue: any = '') {
    let value = defaultValue;
    if (cascade && cascade.value !== undefined && cascade.value !== null) {
      value = cascade.property ? cascade.value[cascade.property] : cascade.value;
    }

    return value;
  }
}
